import { CSVUpload as CSVUploadAPI } from '@occc-app/Activate/apiTypes';

import { CSVUpload as CSVUploadClient } from './types';

type ActionAPI = CSVUploadAPI['attributes']['action'];
type ConfigAPI = CSVUploadAPI['attributes']['config'];
type ActionClient = CSVUploadClient['action'];
type ConfigClient = CSVUploadClient['config'];
type StateAPI = CSVUploadAPI['attributes']['state'];
type StateClient = CSVUploadClient['state'];
type DeserializeAction = (actionAPI: ActionAPI) => ActionClient;
const deserializeAction: DeserializeAction = (apiAction) => {
  switch (apiAction) {
    case 'add_segment_memberships':
      return 'addSegmentMemberships';
  }
};

type DeserializeConfig = (actionAPI: ActionAPI, configAPI: ConfigAPI) => ConfigClient;
const deserializeConfig: DeserializeConfig = (actionAPI, configAPI) => {
  switch (actionAPI) {
    case 'add_segment_memberships':
      return {
        hasHeader: configAPI.has_header,
        membershipColumnIndex: configAPI.membership_column_index,
        segmentId: configAPI.segment_id,
      };
  }
};

type DeserializeState = (stateAPI: StateAPI) => StateClient;
const deserializeState: DeserializeState = (stateAPI) => {
  switch (stateAPI) {
    case 'completed':
      return stateAPI;
    case 'created':
      return stateAPI;
    case 'failed':
      return stateAPI;
    case 'in_progress':
      return 'inProgress';
  }
};

type DeserializeCSVUpload = (apiCSVUpload: CSVUploadAPI) => CSVUploadClient;
export const deserializeCSVUpload: DeserializeCSVUpload = (apiCSVUpload: CSVUploadAPI) => {
  const { action, config, failed_count, file_name, processed_count, state, total_count } =
    apiCSVUpload.attributes;
  return {
    id: apiCSVUpload.id,
    action: deserializeAction(action),
    config: deserializeConfig(action, config),
    failedCount: failed_count,
    fileName: file_name,
    processedCount: processed_count,
    state: deserializeState(state),
    totalCount: total_count,
  };
};
